module.exports = __webpack_public_path__ + "pdf/full-report.7c82982.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/full-report.pdf
// module id = e6Jf
// module chunks = 0